<template>

  <div class="ibox">
    <div class="ibox-title">
       Arquivos disponíveis
    </div>

    <div class="ibox-content">
      <!-- Table -->
      <div class="row flex-fill d-flex justify-content-start">
        <div class="col-md-12 mt-2">
          <table class="table table-borderless table-border table-align">
            <thead>
              <tr>
                <th>Tipo de documento</th>
                <th>Fase</th>
                <th>Nome do documento</th>
                <th>Atualizado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!lastDocuments.length">
                <td colspan="5" class="text-muted">Nenhum documento disponível.</td>
              </tr>
              <tr v-for="document in lastDocuments" :key="document.id">
                <td>{{ translateKind(document.kind) | capitalize }}</td>
                <td>{{ phaseLabel(document.phase) }}</td>
                <td>{{ document.filename }}</td>
                <td>
                  {{ document.createdAt | datetime }}
                  <small v-if="document.recheckCount" class="text-muted d-block">
                    <template v-if="document.recheckedAt">
                      Reconferido em {{ document.recheckedAt | datetime }} ·
                    </template>
                    {{ discardedCaptures(document.recheckCount) }}
                  </small>
                </td>
                <td>
                  <button class="btn btn-outline" @click="download(document)">
                    Baixar documento
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import { discardedCaptures, groupLatestByKindAndPhase, phaseLabel } from '@/models/ticketDocuments'

export default {
  computed: {
    documents() {
      return this.getModels || []
    },
    lastDocuments() {
      return groupLatestByKindAndPhase(this.documents)
        .filter(document => this.$canDownloadKind('cm-frotas', document.kind))
    }
  },
  created() {
    this.params.perPage = 1000
    this.addOrderBy('createdAt')
    this.find()
  },
  data: () => ({
    modelPathPrefix: 'maestro',
    nameModel: 'Ticket',
    showModal: false,
    ticketId: null,
  }),
  methods: {
    discardedCaptures,
    phaseLabel,
    translateKind(kind) {
      const translations = {
        'notification': 'Notificação',
        'warning': 'Advertência por Escrito',
      }
      return translations[kind?.toLowerCase()] || kind
    },
    buildPath() {
      return `maestro/tickets/${this.ticket.id}/documents`
    },
    download(document) {
      this.openLoad()
      this.axios.get(`/maestro/documents/${document.id}/link`)
          .then(response => this.$parse.downloadByLink(response.data))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
    },
    find() {
      this.asyncTemplateSelect()
    }
  },
  mixins: [ModelMapper],
  name: 'Documents',
  props: {
    ticket: {
      required: true,
      type: Object,
    }
  }
}

</script>

<style scoped>

</style>